import { render, staticRenderFns } from "./PropertyLandlordDetail.vue?vue&type=template&id=29724548"
import script from "./PropertyLandlordDetail.vue?vue&type=script&lang=js"
export * from "./PropertyLandlordDetail.vue?vue&type=script&lang=js"
import style0 from "./PropertyLandlordDetail.vue?vue&type=style&index=0&id=29724548&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports